// extracted by mini-css-extract-plugin
module.exports = {"container":"mentions_container__Sq6Xl","title":"mentions_title__QJfq6"};